import { TEndpoint, TEntity, TUserType } from 'contexts/app-context/types'

interface PurposesUsQueryEnabledParams {
  endpoint?: TEndpoint
  userCountry?: string
  userSelectedEntity?: TEntity
  userAccountType?: TUserType
  productId?: string
}

const isPurposesUsQueryEnabled = ({
  endpoint,
  userCountry,
  userSelectedEntity,
  userAccountType,
  productId,
}: PurposesUsQueryEnabledParams) => {
  if (!endpoint || !userCountry || !userSelectedEntity) return false

  return Boolean(userAccountType && productId)
}

export type { PurposesUsQueryEnabledParams }
export { isPurposesUsQueryEnabled }
